import {
  removeWithAnimation,
  insertAfter,
  insertWithAnimation
} from '@/lib/dom';
import { replace } from './replace';

const SELECTOR_SECTION = '.page';
const SELECTOR_VIDEO_IFRAME = '.js-section-video iframe';

const containerWrapper = document.createElement('div');
containerWrapper.classList.add('bcs-takeover__container');
containerWrapper.classList.add('bcs-takeoverContainer');

const container = document.createElement('div');
container.classList.add('bcs-slide');
container.classList.add('bcs-slide--takeover');
containerWrapper.appendChild(container);

export function takeover(newForm, oldForm, { beforeEnter }) {
  if (containerWrapper.parentNode) {
    return replace(newForm, oldForm, { beforeEnter });
  } else {
    const section = document.querySelector(SELECTOR_SECTION);
    return removeWithAnimation(oldForm)
      .then(() => revealContainer(section))
      .then(() =>
        insertWithAnimation(newForm, container, {
          beforeEnter() {
            beforeEnter(container);
          }
        })
      )
      .then(() =>
        Array.from(document.querySelectorAll(SELECTOR_VIDEO_IFRAME)).forEach(
          el => el.setAttribute('src', '')
        )
      );
  }
}

function revealContainer(section) {
  section.classList.add('bcs-takeover');
  insertAfter(containerWrapper, section);
}



// WEBPACK FOOTER //
// ./app/webpack/javascripts/embed/transition_slide/takeover.js